export const SITE_URL = "https://veyronemirates.com";

export const SEO_BY_PATH = {
  "/": {
    title: "VEYRONE — Automotive Trading | Dubai International",
    description:
      "VEYRONE connects UAE automotive supply with international demand through disciplined sourcing, verification and cross-market execution.",
  },
  "/about": {
    title: "About VEYRONE | Our Automotive Sourcing Approach",
    description:
      "Learn about VEYRONE's approach to international vehicle sourcing, tailored solutions and cross-border automotive services.",
  },
  "/global-network": {
    title: "Global Network | VEYRONE",
    description:
      "Explore VEYRONE's international sourcing network and its connections between Dubai and global automotive markets.",
  },
  "/dealers": {
    title: "Vehicle Sourcing for Dealers | VEYRONE",
    description:
      "Discover tailored vehicle sourcing solutions for dealerships and automotive businesses through VEYRONE.",
  },
  "/private-clients": {
    title: "Private Vehicle Sourcing | VEYRONE",
    description:
      "Find a vehicle tailored to your preferences with VEYRONE's personalised international vehicle sourcing service.",
  },
  "/sell-your-car": {
    title: "Sell Your Car to VEYRONE | Vehicle Purchase Enquiries",
    description:
      "Submit your vehicle details and asking price to VEYRONE for consideration by our international automotive team.",
  },
  "/our-process": {
    title: "Our Vehicle Sourcing Process | VEYRONE",
    description:
      "Discover how VEYRONE approaches vehicle requests, sourcing, verification and international delivery.",
  },
  "/contact": {
    title: "Contact VEYRONE | International Vehicle Sourcing",
    description:
      "Contact VEYRONE to discuss your vehicle sourcing requirements and international automotive enquiries.",
  },
  "/cars": {
    title: "Available Cars | VEYRONE — Automotive Trading",
    description:
      "Browse cars currently available from VEYRONE in Dubai and in transit — with full photo sets, inspection summaries and pricing.",
  },
  "/privacy-policy": {
    title: "Privacy Policy | VEYRONE",
    description:
      "How VEYRONE collects, uses and protects the personal data submitted through this website.",
  },
  "/terms": {
    title: "Terms & Conditions | VEYRONE",
    description:
      "The terms and conditions governing the use of the VEYRONE website and its services.",
  },
  "/cookie-policy": {
    title: "Cookie Policy | VEYRONE",
    description:
      "How VEYRONE uses technical cookies and local browser storage on this website.",
  },
  "/admin": {
    title: "Admin | VEYRONE",
    description: "VEYRONE internal administration area.",
    noindex: true,
  },
};
